/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IConvertJsonQueryToUrlResponseSchema } from '../../entities/schemas/ConvertJsonQueryToUrlResponseSchema';

export type TConvertJsonQueryToSeoUrlModel = IModel<
  IConvertJsonQueryToSeoUrlRequest,
  TConvertJsonQueryToSeoUrlResponse
>;

export interface IConvertJsonQueryToSeoUrlRequest {
  /** Список JsonQuery **/
  jsonQueries: any[];
}

export type TConvertJsonQueryToSeoUrlResponse =
  | IConvertJsonQueryToSeoUrlResponse200
  | IConvertJsonQueryToSeoUrlResponse400;

export interface IConvertJsonQueryToSeoUrlResponse200 extends IModelResponse<IConvertJsonQueryToSeoUrlResponse> {
  statusCode: 200;
}

export interface IConvertJsonQueryToSeoUrlResponse400 extends IModelResponse<IConvertJsonQueryToSeoUrlResponseError> {
  statusCode: 400;
}

export interface IConvertJsonQueryToSeoUrlResponse {
  data: IConvertJsonQueryToUrlResponseSchema;
  status: EStatus;
}

export interface IConvertJsonQueryToSeoUrlResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IConvertJsonQueryToSeoUrlResponse | IConvertJsonQueryToSeoUrlResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IConvertJsonQueryToSeoUrlResponse): TResponse200;
  400(response: IConvertJsonQueryToSeoUrlResponseError): TResponse400;
}
